import Vue from 'vue'
import i18n from '@/plugins/i18n'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import formatter from './utils/formatter'
import bus from './bus'
import store from './store'
import '@styles/theme.scss'
import './plugins/element.js'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import { Notification } from 'element-ui';

Vue.config.productionTip = false;
Vue.prototype.$formatter = formatter;
Vue.prototype.$bus = bus;

Vue.component(VueQrcode.name, VueQrcode);

Vue.directive('copy', {
  bind(el, binding) {
    el.addEventListener('click', () => {
      const text = binding.value || el.innerText;
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      Notification.success({
        title: 'copy success'
        
      });
    });
  }
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
